import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  generalRow: {
    display: 'flex',
    padding: '18px 0 12px',
    borderBottom: '1px solid #E4EBF5',
    // [theme.breakpoints.down('sm')]: {
    //   flexDirection: 'column',
    //   padding: '12px 0'
    // },
  },
  tableName: {
    minWidth: '240px',
    padding: '0 30px',
    [theme.breakpoints.down('sm')]: {
      minWidth: '150px',
      padding: '25px 0px 0px 30px '
    },
    
  },
  columnWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    
  },
  column: {
    width: '100%',
    textAlign: 'center',
    textTransform: 'capitalize',
    [theme.breakpoints.down('sm')]: {
        padding: '20px ',
        marginLeft: '28px'
    
      }
   
  },
  sameDay: {
    color: '#1D9DC6',
    fontWeight: 'bold',
    borderBottom: '2px solid #1D9DC6',
    marginBottom: '-12px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0',
      borderBottom: 'none'
    },
  },
  selectedDay: {
    color: '#59758B',
    fontWeight: 'bold',
    borderBottom: '2px solid #59758B',
    marginBottom: '-12px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '0',
      borderBottom: 'none'
    },
  }
}));

export default useStyles;
